<template>
    <modal :show="ids" @close="close" :closeOnbackdrop="false">
        <template slot="header"><h3>Planning</h3></template>
        <template>
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Selected Project(s)</label>
                        </div>
                        {{ Array.isArray(qns) ? qns.join(', ') : qns }}
                    </div>
                    <div class="form-group col-md-12" v-if="tab=='finals'">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Tab</label>
                            <label class="no-wrap font-weight-normal" v-if="isEdit"><input type="checkbox" ref="e_tab" value="tab" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="po" v-model="model.tab" class="form-control" name="tab" @change="refs.e_tab.checked=true">
                            <option value="finals" checked>Finals</option>
                            <option value="planning">Planning</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12" v-if="tab!='finals'||model.tab=='planning'">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Highlight</label>
                            <label class="no-wrap font-weight-normal" v-if="isEdit"><input type="checkbox" ref="e_color" value="color" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="po" v-model="model.color" class="form-control" name="color" :style="'background:'+(model.color?model.color:'none')" @change="refs.e_color.checked=true">
                            <option value="">None</option>
                            <option value="lightgreen">Green</option>
                            <option value="lightblue">Blue</option>
                            <option value="yellow">Yellow</option>
                            <option value="orange">Orange</option>
                            <option value="red">Red</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12" v-if="tab=='finals'&&model.tab!='planning'">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Category</label>
                            <label class="no-wrap font-weight-normal" v-if="isEdit"><input type="checkbox" ref="e_category" value="fcategory" v-model="edit_fields"> Change</label>
                        </div>
                        <div :class="catsel?'':'other-split'">
                            <select ref="po" v-model="catsel" class="form-control" name="catsel" @change="model.fcategory=catsel;refs.e_category.checked=true">
                                <option  v-for="cat in fcategories" :key="cat" :value="cat">{{ cat }}</option>
                                <option value="">Other</option>
                            </select>
                            <input type="search" class="form-control" v-model="model.fcategory" v-if="!catsel" @change="refs.e_category.checked=true">
                        </div>
                    </div>
                    <div class="form-group col-md-12" v-else>
                        <div class="d-flex align-items-center">
                            <label class="w-100">Category</label>
                            <label class="no-wrap font-weight-normal" v-if="isEdit"><input type="checkbox" ref="e_category" value="category" v-model="edit_fields"> Change</label>
                        </div>
                        <div :class="catsel?'':'other-split'">
                            <select ref="po" v-model="catsel" class="form-control" name="catsel" @change="model.category=catsel;refs.e_category.checked=true">
                                <option  v-for="cat in categories" :key="cat" :value="cat">{{ cat }}</option>
                                <option value="">Other</option>
                            </select>
                            <input type="search" class="form-control" v-model="model.category" v-if="!catsel" @change="refs.e_category.checked=true">
                        </div>
                    </div>
                    <div class="form-group col-md-12" v-if="tab!='finals'||model.tab=='planning'">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Approval</label>
                            <label class="no-wrap font-weight-normal" v-if="isEdit"><input type="checkbox" ref="e_approval" value="approval" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="approval" v-model="model.approval" class="form-control" name="approval" @change="refs.e_approval.checked=true">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12" v-if="tab!='finals'||model.tab=='planning'">
                        <div class="d-flex align-items-center">
                            <label class="w-100">PO</label>
                            <label class="no-wrap font-weight-normal" v-if="isEdit"><input type="checkbox" ref="e_po" value="po" v-model="edit_fields"> Change</label>
                        </div>
                        <select ref="po" v-model="model.po" class="form-control" name="po" @change="refs.e_po.checked=true">
                            <option value="1">Yes</option>
                            <option value="0">No</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Notes</label>
                            <label class="no-wrap font-weight-normal" v-if="isEdit"><input type="checkbox" ref="e_notes" value="notes" v-model="edit_fields"> Change</label>
                        </div>
                        <textarea class="form-control" v-model="model.notes" @change="refs.e_notes.checked=true"></textarea>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Last Follow Up</label>
                            <label class="no-wrap font-weight-normal" v-if="isEdit"><input type="checkbox" ref="e_last_followup" value="last_followup" v-model="edit_fields"> Change</label>
                        </div>
                        <date-picker 
                            v-model="model.last_followup"
                            :input-attr="{required:'required',ref:'last_followup'}"
                            :value-type="'format'"
                            type="date"
                            class="s2"
                            ref="start_date"
                            required
                            @change="refs.e_last_followup.checked=true"
                        ></date-picker>
                    </div>
                    <div class="form-group col-md-12">
                        <div class="d-flex align-items-center">
                            <label class="w-100">Next Follow Up</label>
                            <label class="no-wrap font-weight-normal" v-if="isEdit"><input type="checkbox" ref="e_next_followup" value="next_followup" v-model="edit_fields"> Change</label>
                        </div>
                        <date-picker 
                            v-model="model.next_followup"
                            :input-attr="{required:'required',ref:'next_followup'}"
                            :disabled-date="(date) => date < disabledBefore"
                            :default-value="disabledBefore"
                            :value-type="'format'"
                            type="date"
                            class="s2"
                            ref="start_date"
                            required
                            @change="refs.e_next_followup.checked=true"
                        ></date-picker>
                    </div>
                </div>
            </div>
        </template>
        <template slot="footer">
            <button class="btn btn-black" :disabled="isSubmitting" @click="isEdit?submitForm():submitAdd()">
                <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                <template v-else>Update</template>
            </button>
        </template>
    </modal>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { ref } from 'vue'

export default {
    components: { DatePicker },
    data() {
        var date = new Date();
        date.setDate(date.getDate() - 1);
        return {
            apiUrl: '/api/',
            isSubmitting: false,
            managers: false,
            pms: false,
            roles: false,
            distributors: false,
            disabledBefore : date,
            catsel: "",
            categories: ["Weekly Plan","Unplanned","Coming Soon","Final"],
            fcategories: [],
            model: {
                tab: 'planning',
                color: '',
                category: "",
                fcategory: "",
                approval: 0,
                po: 0,
                notes: "",
                last_followup: "",
                next_followup: "",
            },
            refs: {
                e_color : {},
                e_category : {},
                e_approval : {},
                e_po : {},
                e_notes : {},
                e_last_followup : {},
                e_next_followup : {},
            },
            edit_fields: []
        }
    },
    props: {
        show: Boolean,
        ids: {
            type: [Array, Boolean, Number],
            default: 0
        },
        qns: {
            type: [Array, Boolean, String],
            default: ""
        },
        isEdit: {
            type: [Number],
            default: 0
        },
        tab: {
            type: [String],
            default: ""
        },
        rdata: {
            type: [Array, Object, Boolean],
            default: false
        },
        rsurvey: {
            type: [Array, Object, Boolean],
            default: false
        }
    },
    watch: {
        rdata: function(newVal, oldVal) { // watch it
            console.log('newVal', newVal);
            console.log('oldVal', oldVal);
        }
    },
    mounted() {
        this.setOptions()
    },
    methods: {
        getPM() {
            return this.managers.map(function(o){
                if ( o.role == "project-manager" ) return o;
            });
        },
        setOptions() {
            var ff = [];
            console.log('test mount', this.rdata)
            if ( this.rdata !== null && typeof this.rdata === 'object' ) {
                for(let n in this.model) {
                    if ( this.rdata[n] ) {
                        this.model[n] = this.rdata[n];
                        
                        if ( n == 'category' ) {
                            if ( this.categories.includes(this.model[n]) ) {
                                this.catsel = this.model[n];
                            } else {
                                this.catsel = '';
                            }
                        }
                        
                        if ( n == 'fcategory' ) {
                            if ( this.fcategories.includes(this.model[n]) ) {
                                this.catsel = this.model[n];
                            } else {
                                this.catsel = '';
                            }
                        }

                        if ( ['last_followup','next_followup'].includes(n) && this.model[n] && this.model[n].split('/').length == 3 ) {
                            ff = this.model[n].split('/');
                            this.model[n] = ff[2]+'-'+ff[0]+'-'+ff[1];
                        }
                    }
                }
            }

            if ( this.rsurvey ) {
                if ( this.rsurvey.status == "PROCESSED" ) {
                    this.model.color = 'lightgreen';
                }
                if ( this.rsurvey.survey_id ) this.model.survey_id = this.rsurvey.survey_id;
            }

            if ( this.tab && this.tab == 'finals' ) {
                this.model.tab = 'finals';
                this.categories = [];
            }

            if ( !this.isEdit && !Array.isArray(this.ids) && Number(this.ids) ) {
                this.$http.get('/api/planning/sdata/'+this.ids)
                    .then((r) => {
                        var dplan = r.data.planning;
                        if (  dplan ) {
                            if ( dplan.notes ) this.model.notes = dplan.notes;
                            if ( dplan.last_followup ) this.model.last_followup = dplan.last_followup;
                            if ( dplan.next_followup ) this.model.next_followup = dplan.next_followup;
                        }
                    })
            }

            this.$http.get('/api/planning/categories')
            .then((r) => {
                if ( r.data.categories ) {
                    // this.categories = this.tab == 'finals' ? r.data.final_categories : r.data.categories;
                    this.categories = r.data.categories;
                    this.fcategories = r.data.fcategories;
                }
            })

            for(let n in this.refs) {
                this.refs[n] = ref(n);
            }
            console.log('refs',this.refs)
            
        },
        submitAdd() {
            if ( this.isSubmitting ) return false;
            
            this.isSubmitting = true
            let fdata = new FormData()

            for(let n in this.model) {
                fdata.append(n, this.model[n])
            }
            fdata.append('ids', this.ids)

            const api = '/api/planning/add/1';
            this.$http.post(api, fdata).then(() => {
                // this.$router.push('/planning').catch(() => {});
                this.isSubmitting = false
                this.close();
            }).catch(error => {
                this.isSubmitting = false
                console.log(error);
                if ( error.response.data.message ) {
                    alert(error.response.data.message);
                }
            })

            console.log(fdata);
        },
        submitForm() {
            this.isSubmitting = true
            let fdata = new FormData()

            for(let n in this.edit_fields) {
                fdata.append(`edit_fields[${n}]`, this.edit_fields[n])
            }

            for(let n in this.model) {
                fdata.append(n, this.model[n])
            }

            for(let n in this.ids) {
                fdata.append(`ids[${n}]`, this.ids[n])
            }

            fdata.append(`etab`, this.tab)

            this.$http.post('/api/planning/update/1', fdata)
                .then(() => {
                    this.isSubmitting = false
                    this.close()
                    this.reset_form()
                    alert('Updated!')
                })
                .catch(error => {
                    if(error.response.data.message == 'validation_error') {
                        this.validation_error(error.response.data.errors)
                    }
                    this.isSubmitting = false
                })
        },
        add_pdf_row(type) {
            this[`${type}_pdfs`].push({ path: '', orientation: 'L' });
        },
        remove_pdf_row(type, id, key) {
            this[`${type}_pdfs`].splice(key, 1);
            if(this[`${type}_pdfs`].length == 0) {
                this[`${type}_pdfs`] = [{ path: '', orientation: 'L' }];
            }
        },
        close() {
            this.show = false
            this.$emit('close', true)
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('.hasError')).forEach(function(el) { 
                el.classList.remove('hasError')
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                        ref.scrollIntoView()
                    }
                }
            }

            if(Object.keys(errors).length == 1) {
                alert(errors[Object.keys(errors)[0]][0])
            }
        },
        reset_form() {
            this.model = {
                color: '',
                category: "",
                approval: 0,
                po: 0,
                notes: "",
                last_followup: "",
                next_followup: "",
            }
            this.catsel = ""
            this.edit_fields = []
            this.ids = []
        },
        handleHplChange(event) {
            const isChecked = event.target.checked
            this.model.hyperion_price_list = isChecked ? 1 : 0;
        }
    }
};
</script>
<style lang="scss" scoped>
.admin-fields { border: 1px solid #000; }
.admin-fields h3 {background: #000; color: #fff; font-weight: normal; font-size: 15px; text-transform: uppercase; padding: 6px 15px; margin: 0 -15px 15px; }
.table {
    width: 100%;
    th, td {
        padding: 0.5em;
    }
}
.btnAddPdfRow, .btnRemovePdfRow, .btnEditFile {
    font-size: 11px;
    border-radius: 50%;
    height: 24px;
    width: 28px;
    padding: 0;
    float: right;
}
.btnAddPdfRow {
    background-color: #459e45;
    color: #fff;
    &:hover {
        color: #000;
    }
}
.fa-file-pdf {
    font-size: 30px;
}
.pdf-link {
    border: 1px solid #f2f2f2;
    border-radius: 4px;
    width: 160px;
    padding: 0.5em;
    overflow: hidden;
    white-space: nowrap;
}
.form-group {
    .mx-datepicker {
        width: 100%;
    }
}
.other-split {
    select {
        width: 150px;
        display: inline-block;
    }
    input {
        width: calc(100% - 150px);
        display: inline-block;
        margin-left: -5px;
    }
}
.row-btns {
    width: 60px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.modal::v-deep {
    .modal-dialog {
        max-width: 768px;
    }
}
.no-wrap {
    white-space: nowrap;
}
</style>